
const NoAccess = () => (
  <div style={{ textAlign: "center", marginTop: "100px" }}>
    <h2> Access Denied</h2>
    <p>You don't have permission to view this page.</p>
  </div>
);

export default NoAccess;